<template>

</template>

<script>
export default {
  name: "nav-head",
  data() {
    return {
      activeIndex: this.$route.path,
      isRouter: true,
      name: document.cookie ? document.cookie.split("loginName=")[1] : "",
    };
  },
  created() {},
  updated() {
    this.name = document.cookie ? document.cookie.split("loginName=")[1] : "";
    // alert( this.name)
  },
  methods: {
    // handleSelect(router) {
    //   this.$router.push(router);
    // },
  },
};
</script>

<style scoped>
.nav {
  text-align: center;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu-item.is-active {
  font-weight: bold;
}

.el-menu-item.is-active::after {
  content: "";
  position: absolute;
  width: 40px;
  height: 4px;
  background-color: #C0232B;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
}
/* .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #fff;
} */
.el-menu--horizontal > .el-menu-item {
  width: 170px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  border: none;
}

.el-menu-item:not(:last-child)::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 18px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #CCCCCC;
}
</style>



// WEBPACK FOOTER //
// src/components/nav-head.vue